import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DataStorageService } from '../../../services/shared/data-storage.service';
import { NRCInfo } from '../../../models/verification/PeymeVerification.model';
import { AlertService } from '../../../services/shared/alert.service';
import { ConstantValues } from '../../../common/constant-values';

@Component({
  selector: 'app-nrc-box',
  templateUrl: './nrc-box.component.html',
  styleUrl: './nrc-box.component.css'
})
export class NRCBoxComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() nrcGroup: NRCInfo = new NRCInfo();
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() hideRadio: boolean = false;
  @Input() skeletonLoading: boolean = false;
  @Input() oldNrc: any;
  nrcDivisionList: any[] = [];
  nrcTownshipCodeList: any[] = [];
  nrcNationalityCodeList: any[] = [];
  isSkeletonLoading: boolean = false;
  saveAttemped: boolean = false;
  oldNewOptions: { value: string; label: string }[] = [
    { value: 'NewNRC', label: 'New' },
    { value: 'OldNRC', label: 'Old' },
  ];
  isInit: boolean = true;
  currentSelectedLang: any;
  @Output() nrcGroupChange = new EventEmitter<any>();
  @Input() radioGroupName: string = 'oldorNewNrc';
  @Output() oldNrcChange = new EventEmitter<any>();
  @Output() onNrcTypeSwapped = new EventEmitter<'NewNRC' | 'OldNRC'>();

  constructor(
    private dataStorageService: DataStorageService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    // Initialize component data
  }

ngOnChanges(changes: SimpleChanges): void {
  this.currentSelectedLang = localStorage.getItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG);

  // 1. First, analyze if the incoming nrcGroup has actual multi-box data fields filled
  let holdsNewNrcData = false;
  if (this.nrcGroup) {
    const fieldsToCheck = [
      this.nrcGroup.NRCDivisionCode,
      this.nrcGroup.NRCDivisionCodeMM,
      this.nrcGroup.NRCTownshipCode,
      this.nrcGroup.NRCTownshipCodeMM,
      this.nrcGroup.NRCNationality,
      this.nrcGroup.NRCNationalityMM,
      this.nrcGroup.NRCSerialNumber,
      this.nrcGroup.NRCSerialNumberMM
    ];
    holdsNewNrcData = fieldsToCheck.some(value => typeof value === 'string' && value.trim() !== '');
  }

  // 2. RULE 1: If there is active data inside the multi-box properties, it is strictly a New NRC!
  if (holdsNewNrcData) {
    this.nrcGroup.NRCOldOrNew = 'NewNRC';
    
    // Map language locales safely
    this.nrcGroup.NRCSerialNumber = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCSerialNumber : this.nrcGroup.NRCSerialNumberMM;
    this.nrcGroup.NRCNationality = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCNationality : this.nrcGroup.NRCNationalityMM;
    this.nrcGroup.NRCTownshipCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCTownshipCode : this.nrcGroup.NRCTownshipCodeMM;
    this.nrcGroup.NRCDivisionCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCDivisionCode : this.nrcGroup.NRCDivisionCodeMM;
    
    this.loadNRCData();
    if (this.nrcGroup.NRCDivisionCode) {
      this.getNrcData(this.nrcGroup.NRCDivisionCode);
    }
    return; // Exit out safely
  }

  // 3. RULE 2: If the oldNrc string has a value and New NRC boxes are empty, it's an Old NRC!
  if (this.oldNrc && typeof this.oldNrc === 'string' && this.oldNrc.trim() !== '') {
    if (!this.nrcGroup) {
      this.nrcGroup = new NRCInfo();
    }
    this.nrcGroup.NRCOldOrNew = 'OldNRC';
    this.nrcGroup.NRCNumber = this.oldNrc;
    return; // Exit out safely
  }

  // 4. RULE 3: Fallback state for empty object skeletons on initialization
  if (this.nrcGroup) {
    // If the object has an existing explicit assignment, honor it, otherwise default to New
    if (this.nrcGroup.NRCOldOrNew !== 'OldNRC') {
      this.nrcGroup.NRCOldOrNew = 'NewNRC';
    }
    this.loadNRCData();
  }
}
// ngOnChanges(changes: SimpleChanges): void {
//     this.currentSelectedLang = localStorage.getItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG);
    
//     if (changes['nrcGroup'] && this.nrcGroup) {
//       if (this.nrcGroup.NRCOldOrNew !== 'OldNRC') {
//         this.nrcGroup.NRCOldOrNew = 'NewNRC';
//       }
      
//       this.nrcGroup.NRCSerialNumber = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCSerialNumber : this.nrcGroup.NRCSerialNumberMM;
//       this.nrcGroup.NRCNationality = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCNationality : this.nrcGroup.NRCNationalityMM;
//       this.nrcGroup.NRCTownshipCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCTownshipCode : this.nrcGroup.NRCTownshipCodeMM;
//       this.nrcGroup.NRCDivisionCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCDivisionCode : this.nrcGroup.NRCDivisionCodeMM;
      
//       this.loadNRCData();
//       if (this.nrcGroup.NRCDivisionCode) {
//         this.getNrcData(this.nrcGroup.NRCDivisionCode);
//       }
//     } else if (changes['oldNrc']) {
//       // Allow the initial API value to bind directly into the view layout on first load
//       if (!this.nrcGroup) {
//         this.nrcGroup = new NRCInfo();
//       }
//       this.nrcGroup.NRCOldOrNew = 'OldNRC';
//       this.nrcGroup.NRCNumber = this.oldNrc; 
//       this.loadNRCData();
//     }
//   }

// ngOnChanges(changes: SimpleChanges): void {
//   this.currentSelectedLang = localStorage.getItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG);
  
//   // 1. Handle common data setup if nrcGroup is present
//     if (this.nrcGroup) {
//       this.nrcGroup.NRCSerialNumber = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCSerialNumber : this.nrcGroup.NRCSerialNumberMM;
//       this.nrcGroup.NRCNationality = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCNationality : this.nrcGroup.NRCNationalityMM;
//       this.nrcGroup.NRCTownshipCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCTownshipCode : this.nrcGroup.NRCTownshipCodeMM;
//       this.nrcGroup.NRCDivisionCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCDivisionCode : this.nrcGroup.NRCDivisionCodeMM;
      
//       this.loadNRCData();
//       if (this.nrcGroup.NRCDivisionCode) {
//         this.getNrcData(this.nrcGroup.NRCDivisionCode);
//       }
//     }

//     // 2.  FIX: Check initial or dynamic changes for oldNrc independently!
//     if (changes['oldNrc'] && this.oldNrc) {
//       if (!this.nrcGroup) {
//         this.nrcGroup = new NRCInfo();
//       }
//       // Set internal flags and maps the API value directly to the field
//       this.nrcGroup.NRCOldOrNew = 'OldNRC';
//       this.nrcGroup.NRCNumber = this.oldNrc;
//     } 
//     // 3. Fallback: If no old NRC string came from the API, default the radio structure to NewNRC
//     else if (changes['nrcGroup'] && !this.oldNrc && this.nrcGroup && !this.nrcGroup.NRCOldOrNew) {
//       this.nrcGroup.NRCOldOrNew = 'NewNRC';
//     }
//   }

onOldNrcValueInput(value: any): void {
    // 1. Keep internal tracking structures completely unified
    if (!this.nrcGroup) {
      this.nrcGroup = new NRCInfo();
    }
    this.nrcGroup.NRCNumber = value;
    this.oldNrc = value;
    console.log('oldNrc', this.oldNrc, this.nrcGroup.NRCNumber);

    // 2. 🌟 CRITICAL: Emit the exact string token typed by the user directly to the parent
    this.oldNrcChange.emit(value); 
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['nrcGroup']) {
  //     this.nrcGroup.NRCOldOrNew = 'NewNRC';
  //     this.currentSelectedLang = localStorage.getItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG);
  //     this.nrcGroup.NRCSerialNumber = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCSerialNumber : this.nrcGroup.NRCSerialNumberMM;
  //     this.nrcGroup.NRCNationality = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCNationality : this.nrcGroup.NRCNationalityMM;
  //     this.nrcGroup.NRCTownshipCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCTownshipCode : this.nrcGroup.NRCTownshipCodeMM;
  //     this.nrcGroup.NRCDivisionCode = this.currentSelectedLang === 'en' ? this.nrcGroup.NRCDivisionCode : this.nrcGroup.NRCDivisionCodeMM;
  //     this.loadNRCData();
  //     if (this.nrcGroup.NRCDivisionCode) {
  //       this.getNrcData(this.nrcGroup.NRCDivisionCode);
  //     }
  //     // this.cdr.markForCheck();
  //   }else{
  //     this.nrcGroup = new NRCInfo();
  //     this.nrcGroup.NRCOldOrNew = 'OldNRC';
  //      this.loadNRCData();
  //   }
  // }

  async loadNRCData() {
    const divisionAndNrcData: any = await this.dataStorageService.divisionNrcApi();
    if (divisionAndNrcData) {
      this.nrcDivisionList = this.currentSelectedLang == 'en' ? divisionAndNrcData.NRCDivisionCodes : divisionAndNrcData.NRCDivisionCodesMM ;
      this.nrcNationalityCodeList = this.currentSelectedLang == 'en' ? divisionAndNrcData.NRCNationalities : divisionAndNrcData.NRCNationalitiesMM;
    }
  }

  async getNrcData(divisionCode: string, deleteOldTownshipCode = false) {
    if (divisionCode) {
      const nrcTownshipList = await this.dataStorageService.nrcTownshipApi(
        divisionCode, this.currentSelectedLang
      );
      this.nrcTownshipCodeList = nrcTownshipList;
      // if(!this.isInit){
        if (deleteOldTownshipCode) {
          this.nrcGroup.NRCTownshipCode = '';
        }
      //   this.isInit = false;
      // }
    }
  }


  // changeNrcType(type: 'NewNRC' | 'OldNRC'): void {
  //   const fieldsToCheck = [
  //     this.nrcGroup.NRCDivisionCode,
  //     this.nrcGroup.NRCTownshipCode,
  //     this.nrcGroup.NRCNationality,
  //     this.nrcGroup.NRCSerialNumber,
  //     this.nrcGroup.NRCNumber,
  //   ];

  //   const checked = fieldsToCheck.map(
  //     (value) => typeof value === 'string' && value.trim() !== ''
  //   );
  //   const haveNrcData = checked.some(Boolean);

  //   if (haveNrcData) {
  //     const message = 'Changing the NRC type will erase your current inputs. Confirm to proceed?';
  //     this.alertService
  //       .confirm(message)
  //       .then((result) => {
  //         if (result.isConfirmed) {
  //           // 🌟 User confirmed change: Wipe out all data containers completely
  //           this.nrcGroup = new NRCInfo();
  //           this.nrcGroup.NRCOldOrNew = type;
  //           this.oldNrc = ''; 
            
  //           // Sync empty values immediately back up to the parent component
  //           this.oldNrcChange.emit('');
  //           this.onNrcTypeSwapped.emit(type); 
  //         } else {
  //           // Cancelled: Keep existing values and revert radio selection state
  //           this.nrcGroup.NRCOldOrNew = type === 'NewNRC' ? 'OldNRC' : 'NewNRC';
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error during confirmation on type change:', error);
  //       });
  //   } else {
  //     // 🌟 Form was empty: set the new type, blank out old data properties
  //     this.nrcGroup = new NRCInfo();
  //     this.nrcGroup.NRCOldOrNew = type;
  //     this.oldNrc = '';

  //     this.oldNrcChange.emit('');
  //     this.onNrcTypeSwapped.emit(type);
  //   }
  // }

  changeNrcType(type: 'NewNRC' | 'OldNRC'): void {
  //  FIX 1: If nrcGroup is null or undefined, initialize it immediately
  if (!this.nrcGroup) {
    this.nrcGroup = new NRCInfo();
    this.nrcGroup.NRCOldOrNew = type;
    this.oldNrc = '';
    
    // Sync the freshly created object and values back to the parent
    this.nrcGroupChange.emit(this.nrcGroup); 
    this.oldNrcChange.emit('');
    this.onNrcTypeSwapped.emit(type);
    return; // Stop here since it was null and empty anyway!
  }

  // If it wasn't null, run your safe verification checks safely
  const fieldsToCheck = [
    this.nrcGroup.NRCDivisionCode,
    this.nrcGroup.NRCTownshipCode,
    this.nrcGroup.NRCNationality,
    this.nrcGroup.NRCSerialNumber,
    this.nrcGroup.NRCNumber,
  ];

  const checked = fieldsToCheck.map(
    (value) => typeof value === 'string' && value.trim() !== ''
  );
  const haveNrcData = checked.some(Boolean);

  if (haveNrcData) {
    const message = 'Changing the NRC type will erase your current inputs. Confirm to proceed?';
    this.alertService
      .confirm(message)
      .then((result) => {
        if (result.isConfirmed) {
          // User confirmed change: Wipe out all data containers completely
          this.nrcGroup = new NRCInfo();
          this.nrcGroup.NRCOldOrNew = type;
          this.oldNrc = ''; 
          
          // 🌟 FIX 2: Emit the brand new object back to the parent along with other updates
          this.nrcGroupChange.emit(this.nrcGroup);
          this.oldNrcChange.emit('');
          this.onNrcTypeSwapped.emit(type); 
        } else {
          // Cancelled: Keep existing values and revert radio selection state
          this.nrcGroup.NRCOldOrNew = type === 'NewNRC' ? 'OldNRC' : 'NewNRC';
          this.nrcGroupChange.emit(this.nrcGroup);
        }
      })
      .catch((error) => {
        console.error('Error during confirmation on type change:', error);
      });
  } else {
    // Form was empty: set the new type, blank out old data properties
    this.nrcGroup = new NRCInfo();
    this.nrcGroup.NRCOldOrNew = type;
    this.oldNrc = '';

    // 🌟 FIX 3: Emit the brand new object back to the parent here too
    this.nrcGroupChange.emit(this.nrcGroup);
    this.oldNrcChange.emit('');
    this.onNrcTypeSwapped.emit(type);
  }
}

  isSearchValid(): boolean {
    // Validation logic for search input
    return true;
  }
}
